/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useRef, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";
import useFamiliaProduto from "./useFamiliaProduto";

const usePrazoRegra = ({ gruposegmento = 0, filters }) => {
  const formikRef = useRef();
  const { familiasProduto } = useFamiliaProduto({ formikRef });

  const [prazoRegras, setPrazoRegra] = useState([]);

  useEffect(() => {
    const fetchPrazoRegra = async () => {
      const result = [];
      await db.prazoRegra.filter((a) => a.ativo).each((item) => result.push(item));

      const filteredResult = result
        .filter((pr) =>
          pr.ativo &&
          (gruposegmento > 0 ? pr.grupoSegmentoId === gruposegmento : true) &&
          (filters?.grupoSegmento ? pr.grupoSegmentoId === filters.grupoSegmento : true)
        )
        .map((prazoRegra) => {
          const agrupamentos = prazoRegra.agrupamento.split(", ");

          const familias = (familiasProduto || []).filter((f) => {
            const matchesId = filters?.familia ? f.id === filters.familia : true;
            const matchesGrupoProduto = filters?.grupoProduto ? f.grupoMaterialId === filters.grupoProduto : true;
            return matchesId && matchesGrupoProduto && agrupamentos.includes(f.codigo);
          });

          return familias.length > 0 ? {
            ...prazoRegra,
            familias,
            agrupamentos,
            gruposMaterial: familias.map((e) => e.grupoMaterialId),
          } : null;
        })
        .filter((prazoRegra) => prazoRegra !== null);

      setPrazoRegra(filteredResult);
    };

    fetchPrazoRegra();
  }, [familiasProduto, filters?.familia, filters?.grupoProduto, filters?.grupoSegmento, gruposegmento]);

  const familiasPrazoDisponiveis = useMemo(() => {
    const result = new Set();
    if (prazoRegras) {
      for (const prazoRegra of prazoRegras) {
        if (prazoRegra?.familias) {
          for (const familia of prazoRegra.familias) {
            result.add(familia.id);
          }
        }
      }
    }
    return Array.from(result);
  }, [prazoRegras]);

  const gruposSegmentoPrazoDisponiveis = useMemo(() => {
    const result = new Set();
    if (prazoRegras) {
      for (const prazoRegra of prazoRegras) {
        if (prazoRegra?.grupoSegmentoId) {
          result.add(prazoRegra?.grupoSegmentoId);
        }
      }
    }
    return Array.from(result);
  }, [prazoRegras]);

  return {
    prazoRegras,
    familiasPrazoDisponiveis,
    gruposSegmentoPrazoDisponiveis
  };
};

export default usePrazoRegra;
